import logo from "../../oversight-core/assets/images/chloride-logo.png";

interface IProps {
  width?: number;
  height?: number;
}

const Logo = (props: IProps) => {
  return (
    <a
      href="https://chlorideexide.com/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: "inline-block" }}
    >
      <img
        src={logo}
        alt="chloride-logo"
        width={props.width || 60}
        height={props.height || 60}
      />
    </a>
  );
};

export default Logo;
